import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppForm, DynamicFormContainer } from "../../../../components";
import { DisplaySpinnerContext, FormContextProvider, TabPanelContext } from "../../../../context/ContextIndex";
import { getPezodeProductSchema, getPezodeProductDefaultValue } from "../../pezode-product/create/schema";
import { selectSessionConfig } from "../../../../store/store-selector";
import { useSelector } from "react-redux";
import { useFetchListData } from "../../../../hooks/useFetchListData";

const PezodeProductCreate = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation();

  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const _tabContextObject = useContext(TabPanelContext);
  const _tabContext = _tabContextObject.getTabFormContext();

  const [formData, setFormData] = useState({
    pezodeProductSchema: getPezodeProductSchema({ consumableProductList: [] }),
    appformdata: null,
  });

  const selectedPezodeProduct = _tabContext.data?.selectedPezodeProduct;

  const existingProducts = _tabContext?.data?.consumableproductmap ? _tabContext?.data?.consumableproductmap : [];

  const _formattedProducts = existingProducts
    .filter((item) => !selectedPezodeProduct || item.id !== selectedPezodeProduct.id)
    .map((item) => ({
      ConsumableProduct: item.ConsumableProduct
    }));

  const ConsumableProductList = useFetchListData(settingsConfig.businessCode, settingsConfig.countryCode, "getConsumableProductList", "consumableproduct");

  const defaultFormValues = selectedPezodeProduct
    ? selectedPezodeProduct // If editing, use selected pezode
    : getPezodeProductDefaultValue();

  const onPezodeProductSubmit = (data) => {
    const newProduct = {
      ...data,
      id: selectedPezodeProduct ? selectedPezodeProduct.id : _tabContext.data?.consumableproductmap?.length || 0,
      PezodeProductMapId: selectedPezodeProduct ? selectedPezodeProduct.PezodeProductMapId : null
    };

    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        consumableproductmap: _tabContext.data?.consumableproductmap
          ? (
            _tabContext.data.consumableproductmap.some(pezode => pezode.id === newProduct.id)
              ? _tabContext.data.consumableproductmap.map(pezode =>
                pezode.id === newProduct.id
                  ? newProduct  // If pezode with the same ID exists, replace it
                  : pezode     // Otherwise, keep the original pezode
              )
              : [..._tabContext.data.consumableproductmap, newProduct]  // If no pezode with the same ID exists, add new one
          )
          : [newProduct],  // If there are no existing pezode, create an array with the new one
        selectedPezodeProduct: null
      },
      isDirty: true
    });


    onSubmit(); // Close form after submit
  };

  //Use Effects
  useEffect(() => {
    const setFormSchema = () => {
      try {
        let _lookUpData = {};
        _lookUpData.consumableProductList = [];

        if (ConsumableProductList.length) {
          _lookUpData.consumableProductList = ConsumableProductList.map((item) => {
            return {
              id: item.ConsumableProductId,
              label: item.ShortName,
            };
          });
        }

        setFormData((prevstate) => ({
          ...prevstate,
          pezodeProductSchema: getPezodeProductSchema(_lookUpData, _formattedProducts),
        }));

        spinnerCtx.setLoadingIndicator(false);

      } catch (err) {
        alert(err);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    if (ConsumableProductList) {
      setFormSchema();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ConsumableProductList]);

  return (
    <FormContextProvider
      schema={formData.pezodeProductSchema}
      defaultValues={defaultFormValues}
      appformdata={formData.appformdata}
    >
      <AppForm onSubmit={onPezodeProductSubmit}>
        <DynamicFormContainer
          header={t("navigationMenu.products")}
          onCancel={onCancel}
          onSaveLabel={t("generic.save")}
        />
      </AppForm>
    </FormContextProvider>
  );
};

export default PezodeProductCreate;
